import { render } from "./HospitalProfile.vue?vue&type=template&id=11176878&scoped=true"
import script from "./HospitalProfile.vue?vue&type=script&lang=js"
export * from "./HospitalProfile.vue?vue&type=script&lang=js"

import "./HospitalProfile.vue?vue&type=style&index=0&id=11176878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11176878"]])

export default __exports__